/* eslint-disable import/first,no-func-assign */
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgSecurityWaf = props => /*#__PURE__*/React.createElement("svg", _extends({}, props, {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64",
  "aria-hidden": !props['aria-label'],
  focusable: "false"
}), /*#__PURE__*/React.createElement("path", {
  d: "m58 33.94 2-2v-12l-2-2h-8.4V8l-2-2H6L4 8v12l2 2h8.39v8H6l-2 2v12l2 2h8.39v10l2 2H58l2-2V44l-2-2h-8.4v-8l8.4-.06Zm-2-4H39.19V22H56v7.94ZM45.6 10v8H28.8v-8h16.8ZM8 10h16.8v8H8v-8Zm10.39 12h16.8v8h-16.8v-8ZM8 33.94h16.8v8H8v-8ZM18.39 54v-8h16.8v8h-16.8ZM56 54H39.19v-8H56v8ZM45.61 42H28.8v-8h16.8l.01 8Z"
}));

export default SvgSecurityWaf;